import {
  GET_METRICS_ENGAGEMENT_REQUEST,
  GET_METRICS_ENGAGEMENT_REQUEST_SUCCEEDED,
  GET_METRICS_ENGAGEMENT_REQUEST_FAILED
} from "../constants/company";

export const company = (
  state = {
    isFetching: false,
    data: [],
    error: {}
  }, action) => {
  let newState = {...state};

  switch (action.type) {
    case GET_METRICS_ENGAGEMENT_REQUEST:
      newState.isFetching = true;
      return newState;

    case GET_METRICS_ENGAGEMENT_REQUEST_SUCCEEDED:
      newState.isFetching = false;
      newState.data = action.data;
      newState.error = {};
      return newState;

    case GET_METRICS_ENGAGEMENT_REQUEST_FAILED:
      newState.isFetching = false;
      newState.error = action.error;
      newState.data = [];
      return newState;

    default:
      return newState;
  }
};
